export default {
  data() {
    return {
      isMobile: false, // Initially set to false
    };
  },
  created() {
    // Add a resize event listener when the component is created
    window.addEventListener("resize", this.updateIsMobile);
    // Set the initial value based on the current screen width
    this.updateIsMobile();
  },
  beforeDestroy() {
    // Remove the resize event listener to prevent memory leaks
    window.removeEventListener("resize", this.updateIsMobile);
  },
  methods: {
    updateIsMobile() {
      // Dynamically update the isMobile property based on screen width
      this.isMobile = window.innerWidth <= 760;
    },
  },
};
